export default {
  applications: null
};